import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import {Button, Drawer, message, Modal} from "antd";
import {ExpandOutlined, LinkOutlined, QuestionCircleOutlined,CodeOutlined} from "@ant-design/icons";
import MyRawData from "../../components/MyRawData";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
import DataUtil from "../../utils/DataUtil";

const {confirm} = Modal

const AiGameLogs = (props: any, ref:any) => {

    // const formRef = useRef();
    const actionRef = useRef<ActionType>();

    // const [total, setTotal] = useState(0);
    // const [mainData, setMainData] = useState<any[]>();
    const [mainQuery, setMainQuery] = useState<any>();

    const [openForm, setOpenForm] = useState(false);
    const [openForm2, setOpenForm2] = useState(false);
    const [form2Text, setForm2Text] = useState([]);

    useEffect(() => {
        actionRef.current?.reload();
    }, [mainQuery]);

    useImperativeHandle(ref, () => {
        return {
            openEditor: (id: number) => {
                setMainQuery({gameId: id, trendValue: 1000});
                setOpenForm(true);
            }
        }
    });

    const columns: any[] = [
        {
            title: '更新日期',
            dataIndex: 'trendDate',
            align: 'center' as 'center',
            valueType: "date"
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        // },
        {
            title: 'Keyword',
            dataIndex: 'keyword',
        },
        {
            title: 'Trends热度',
            dataIndex: 'trendValue',
            align: 'right' as 'right',
        },
        {
            title: '7天文章率',
            dataIndex: 'newsPercent',
            align: 'right' as 'right',
            render: (v: any, r: any) => v != null && typeof v === 'number' ?
                <a onClick={() => onOpenForm2(r)}>{(v * 100).toFixed(2) + "%"} </a>
                : '-',
        },

    ];

    const onOpenForm2 = async (r: any) => {
        const res = await FetchUtil.awaitFetch('/mallApi/aiGame/keyDetail', {id: r.id});
        // setForm2Text(res.data.remark);
        // setOpenForm2(true);
        try {
            let remark = res.data.remark
            remark = remark.replace(/[\u0000-\u001F]+/g, "");
            const data = JSON.parse(remark);
            setForm2Text(data.organic);
            setOpenForm2(true);
        } catch (e) {
            message.error({content: "没有找到7天文章明细数据" + e})
            setForm2Text([]);
        }
    }

    const closeForm2 = () => {
        setOpenForm2(false);
    }

    return (
        <Drawer placement="right"
                width={720}
                open={openForm}
                onClose={() => {
                    setOpenForm(false);
                    setMainQuery(undefined);
                }}
                title={"日志"}
                forceRender={true}>

            <ProTable key='contract'
                      actionRef={actionRef}
                      rowKey='id'
                      columns={columns}
                      size="small"
                      search={false}
                      pagination={{showQuickJumper: true, showSizeChanger: true}}
                      request={async (
                          params // , sort, filter,
                      ) => {
                          if (mainQuery) {
                              const query: any = {
                                  query: {...mainQuery},
                                  page: {pageSize: params.pageSize, pageNo: params.current, orderBy: "trend_date desc, keyword"}
                              }
                              const res = await FetchUtil.awaitFetch('/mallApi/aiGame/keyList', query);
                              // setMainData(res.data.list);
                              return {
                                  success: true,
                                  data: res.data.list,
                                  total: res.data.total,
                              }
                          } else {
                              return {success: true, data: []}
                          }
                      }}
            />

            <Drawer placement="right"
                    width={680}
                    open={openForm2}
                    onClose={closeForm2}
                    title={<span><ExpandOutlined/> 7天文章明细</span>}>
                {/*<MyRawData rawData={form2Text} label="Post Raw"/>*/}
                {form2Text?.map((r:any) =>
                    <p>
                        <a href={r.link} target="_blank">{r.title}</a><br />
                        {r.date} ({r.link.split("/")[2]})
                    </p>
                )}
            </Drawer>
        </Drawer>
    );
}
export default forwardRef(AiGameLogs)
